import { useEffect, useRef } from "react";

declare global {
  interface Window {
    turnstile?: { render: (el: HTMLElement, opts: { sitekey: string; callback: (t: string) => void }) => string; remove: (id: string) => void };
  }
}

const SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined;

/** Renders the Turnstile check when a site key is configured; in development it renders nothing. */
export function Turnstile({ onToken }: { onToken: (token: string) => void }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!SITE_KEY || !ref.current) return;
    let id: string | undefined;
    const mount = () => { if (ref.current && window.turnstile) id = window.turnstile.render(ref.current, { sitekey: SITE_KEY, callback: onToken }); };
    if (window.turnstile) mount();
    else {
      const s = document.createElement("script");
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      s.async = true;
      s.onload = mount;
      document.head.appendChild(s);
    }
    return () => { if (id) window.turnstile?.remove(id); };
  }, [onToken]);
  return SITE_KEY ? <div ref={ref} /> : null;
}
